export const getClientSecret = (ownerId: string) => {
  return [
    localStorage.getItem(`_hp_mbe_${ownerId}_client_id`),
    localStorage.getItem(`_hp_mbe_${ownerId}_secret_id`),
  ]
}
